export { isIpAddress } from "@smithy/util-endpoints";
